import { defineMessages } from 'react-intl'

export default defineMessages({
  creditCard: {
    id: 'pay.creditCard',
    defaultMessage: 'Bank card',
  },
  cardNumber: {
    id: 'Redeem.pay.cardNumber',
    defaultMessage: 'Card number',
  },
  nameOnCard: {
    id: 'Redeem.pay.nameOnCard',
    defaultMessage: 'Name on card',
  },
  expiration: {
    id: 'Redeem.pay.expiration',
    defaultMessage: 'Exp. (MM/YY)',
  },
  CVCCode: {
    id: 'Redeem.pay.CVCCode',
    defaultMessage: 'CVC Code',
  },
  securePayments: {
    id: 'pay.secure',
    defaultMessage: 'Safe card payment via a secure connection.',
  },
  invalidCardNumber: {
    id: 'Redeem.pay.invalidCardNumber',
    defaultMessage:
      'Please check that the card number has been entered correctly',
  },
  invalidCardHolder: {
    id: 'Redeem.pay.invalidCardHolder',
    defaultMessage:
      "Please ensure the cardholder's name has been entered correctly",
  },
  invalidCvcCode: {
    id: 'Redeem.pay.invalidCvcCode',
    defaultMessage: 'Please check that you have entered a valid CVC',
  },
  invalidExpiryMonth: {
    id: 'Redeem.pay.invalidExpiryMonth',
    defaultMessage: 'Please check the correct expiry date has been entered',
  },
  invalidExpiryYear: {
    id: 'Redeem.pay.invalidExpiryYear',
    defaultMessage: 'Please check the correct expiry date has been entered',
  },
  pay_try_again: {
    id: 'pay_try_again',
    defaultMessage: 'Try again',
  },
  pay_load_error_heading: {
    id: 'pay_load_error_heading',
    defaultMessage: 'Couldn’t load payment methods',
  },
  pay_load_error_text: {
    id: 'pay_load_error_text',
    defaultMessage:
      'We ran into an error while loading our payment methods. Do you want to try again?',
  },
})
